// InventoryAdminInventory - Top Performing Products Component
import React from 'react';
import '../../../../assests/css/admin/Analytics/TopProducts/TopProducts.css';

const TopProducts = () => {
  const products = [
    {
      icon: '📱',
      iconColor: 'phone',
      name: 'iPhone 15 Pro Max',
      category: 'Smartphone',
      sold: '42 Units Sold',
      price: '$41,958',
      change: '+8.2%',
      changeType: 'positive'
    },
    {
      icon: '💻',
      iconColor: 'laptop',
      name: 'MacBook Air M2',
      category: 'Computing',
      sold: '28 Units Sold',
      price: '$33,572',
      change: '+5.4%',
      changeType: 'positive'
    },
    {
      icon: '🎧',
      iconColor: 'headphones',
      name: 'AirPods Max',
      category: 'Accessories',
      sold: '58 Units Sold',
      price: '$12,814',
      change: '-6.4%',
      changeType: 'negative'
    }
  ];

  return (
    <div className="InventoryAdminInventory-top-products">
      <div className="InventoryAdminInventory-products-header">
        <div>
          <div className="InventoryAdminInventory-products-title">
            Top Performing Products
          </div>
          <div className="InventoryAdminInventory-products-subtitle">
            Exactly 3 out listed the finest
          </div>
        </div>
        <div className="InventoryAdminInventory-view-report">
          <span>View Detailed Report</span>
          <span>→</span>
        </div>
      </div>

      <div className="InventoryAdminInventory-products-list">
        {products.map((product, index) => (
          <div key={index} className="InventoryAdminInventory-product-item">
            <div className={`InventoryAdminInventory-product-icon ${product.iconColor}`}>
              {product.icon}
            </div>
            <div className="InventoryAdminInventory-product-details">
              <div className="InventoryAdminInventory-product-name">
                {product.name}
              </div>
              <div className="InventoryAdminInventory-product-category">
                {product.category}
                <span className="InventoryAdminInventory-sold-badge">
                  {product.sold}
                </span>
              </div>
            </div>
            <div className="InventoryAdminInventory-product-stats">
              <div className="InventoryAdminInventory-product-price">
                {product.price}
              </div>
              <div className={`InventoryAdminInventory-product-change ${product.changeType}`}>
                <span>{product.changeType === 'positive' ? '↑' : '↓'}</span>
                <span>{product.change}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopProducts;